import {
  IconBarbell,
  IconBell,
  IconBrowser,
  IconClipboard,
  IconGraph,
  IconLayoutGrid,
  IconListNumbers,
  IconMap,
  IconMoneybag,
  IconPencil,
  IconPencilBolt,
  IconPlus,
  IconReportMoney,
  IconScript,
  IconTicket,
  IconTrophy,
  IconUserCircle,
  IconUsers,
  IconWallet,
  IconWorldUp,
} from '@tabler/icons-react';
import { MenuAudience } from '@/utils/menuVisibility';
import IconLeaderboardCuston from '../Icon/IconLeaderboardCuston';

export type MenuEventLink = {
  id: number;
  title: string;
  step: string;
  links: {
    id: number;
    label: string;
    leftSection: React.ReactElement;
    to: string;
  }[];
};

export type MenuLink = {
  id: number;
  label: string;
  icon: React.ElementType;
  href: string;
  /**
   * Quem vê o item do menu principal (padrão: todos). Qualquer conta organiza eventos; as
   * ferramentas aparecem com o primeiro evento próprio ou delegado (utils/menuVisibility).
   */
  visibleTo?: MenuAudience[];
  /** Funções da equipe do evento que não usam este item (ex.: Financeiro não lança resultados). */
  hiddenForStaffRoles?: string[];
};

export const navigationLinks: MenuLink[] = [
  {
    id: 1,
    label: 'tabela de eventos',
    icon: IconLayoutGrid,
    href: '/dashboard/evento/tabela',
    visibleTo: ['admin', 'owner', 'team'],
  },
  {
    id: 10,
    // Qualquer conta cria o próprio evento; publicar é que exige os dados de organizador
    label: 'criar evento',
    icon: IconPlus,
    href: '/dashboard/evento/cadastrar/novo',
  },
  {
    id: 2,
    label: 'Contas de recebimento',
    icon: IconWallet,
    href: '/dashboard/organizador/oauth',
    visibleTo: ['owner'],
  },
  {
    id: 3,
    label: 'usuarios',
    icon: IconUsers,
    href: '/dashboard/usuarios/todos',
    visibleTo: ['admin', 'owner'],
  },
  {
    id: 4,
    label: 'pagamentos',
    icon: IconMoneybag,
    href: '/dashboard/pagamento/tabela',
    visibleTo: ['admin', 'finance'],
  },
  {
    id: 8,
    label: 'movimentos',
    icon: IconBarbell,
    href: '/dashboard/movimentos',
    visibleTo: ['admin'],
  },
  {
    id: 9,
    // Notificações de toda a plataforma por canal (hoje e-mail; depois WhatsApp etc.).
    // O organizador vê as do evento no menu do painel.
    label: 'notificações',
    icon: IconBell,
    href: '/dashboard/notificacoes',
    visibleTo: ['admin'],
  },
  {
    id: 6,
    // Arena de competições (mesmas regras da página inicial), para todos
    label: 'eventos',
    icon: IconTrophy,
    href: '/dashboard/eventos',
  },
  {
    id: 7,
    // Inscrições feitas logado ou com o e-mail da conta, para todos
    label: 'minhas inscrições',
    icon: IconTicket,
    href: '/dashboard/minhas-inscricoes',
  },
  {
    id: 5,
    label: 'meu perfil',
    icon: IconUserCircle,
    href: '/dashboard/meu-perfil',
  },
];

export const navigationOrganizerLinks: MenuLink[] = [
  {
    id: 1,
    label: 'painel do organizador',
    icon: IconGraph,
    href: '/dashboard/evento/:eventId/dashboard/painel-organizador',
  },
  {
    id: 7,
    // Todos os atletas do evento, com filtros e planilha (Staff sem contato e documento)
    label: 'atletas',
    icon: IconUsers,
    href: '/dashboard/evento/:eventId/dashboard/atletas',
  },
  {
    id: 6,
    // Quem corre quando, onde e em qual raia; Staff e Financeiro só consultam
    label: 'baterias',
    icon: IconListNumbers,
    href: '/dashboard/evento/:eventId/dashboard/baterias',
  },
  {
    id: 3,
    label: 'subir resultados',
    icon: IconPencilBolt,
    href: '/dashboard/evento/:eventId/dashboard/subir-resultados',
    hiddenForStaffRoles: ['FINANCEIRO'],
  },
  {
    id: 4,
    label: 'leaderboard',
    icon: IconLeaderboardCuston,
    href: '/dashboard/evento/:eventId/dashboard/leaderboard',
  },
  {
    id: 5,
    label: 'notificações',
    icon: IconBell,
    href: '/dashboard/evento/:eventId/dashboard/notificacoes',
  },
];

export const navigationCreateEventLinks: MenuEventLink[] = [
  {
    id: 1,
    title: 'INFORMAÇÕES BÁSICAS',
    step: '1',
    links: [
      {
        id: 11,
        label: 'Informações Básicas',
        leftSection: <IconClipboard />,
        to: '/dashboard/evento/cadastrar/:eventId',
      },
      {
        id: 12,
        label: 'Endereço',
        leftSection: <IconMap />,
        to: '/dashboard/evento/cadastrar/:eventId/endereco',
      },
      {
        id: 13,
        label: 'Categorias',
        leftSection: <IconLayoutGrid />,
        to: '/dashboard/evento/cadastrar/:eventId/categorias',
      },
    ],
  },
  {
    id: 2,
    title: 'DIVULGAÇÃO',
    step: '2',
    links: [
      {
        id: 21,
        label: 'Pagina de inscrição',
        leftSection: <IconScript />,
        to: '/dashboard/evento/cadastrar/:eventId/descricao',
      },
      {
        id: 22,
        label: 'Gateway de pagamento',
        leftSection: <IconWorldUp />,
        to: '/dashboard/evento/cadastrar/:eventId/gateway-pagamento',
      },
      {
        id: 23,
        label: 'Personalização',
        leftSection: <IconPencil />,
        to: '/dashboard/evento/cadastrar/:eventId/personalizacao',
      },
      {
        id: 24,
        label: 'Venda de inscrições',
        leftSection: <IconReportMoney />,
        to: '/dashboard/evento/cadastrar/:eventId/ticket',
      },
      {
        id: 25,
        label: 'Cupom de desconto',
        leftSection: <IconTicket />,
        to: '/dashboard/evento/cadastrar/:eventId/cupom',
      },
      {
        id: 26,
        label: 'Publicar',
        leftSection: <IconBrowser />,
        to: '/dashboard/evento/cadastrar/:eventId/publicar',
      },
    ],
  },
  {
    id: 3,
    title: 'WODS',
    step: '3',
    links: [
      {
        id: 31,
        label: 'WODS',
        leftSection: <IconBarbell />,
        to: '/dashboard/evento/cadastrar/:eventId/wod',
      },
      {
        id: 32,
        label: 'Pontuação',
        leftSection: <IconTrophy />,
        to: '/dashboard/evento/cadastrar/:eventId/pontuacao',
      },
    ],
  },
];
